<template>
  <div class="cart-page">
    <!-- 左侧模型列表区域 -->
    <div class="left-section">
      <div class="section-header">全部模型（共{{ total }}件）</div>
      <div class="selection-bar">
        <div class="select-column">
          <input type="checkbox" id="select-all" class="checkbox" v-model="isAllChecked" @change="handleSelectAll">
          <button class="delete-selected-btn" @click="handleDeleteSelected"
            :disabled="selectedCount === 0">删除所选</button>
        </div>
        <div class="info-column">模型信息</div>
        <div class="license-column price-column">授权类型</div>
        <div class="price-column">价格</div>
        <div class="action-column">操作</div>
      </div>

      <!-- 动态循环渲染模型项 -->
      <div class="model-item" v-for="(item, index) in items" :key="item.id || index">
        <div class="select-column">
          <input type="checkbox" class="model-checkbox" v-model="item.checked" @change="handleItemCheck(index)">
        </div>
        <div class="info-column" @click="goToDetail(item.modelId)">
          <img :src="item.previewUrl[0]" :alt="item.title || '模型图片'" class="model-img">
          <div class="model-text">
            <div class="model-name">{{ item.title || '未命名模型' }}</div>
            <div class="tags">
              <!-- 循环显示所有文件格式标签 -->
              <span class="tag" v-for="(format, idx) in item.fileFormat" :key="idx">
                {{ format.replace('.', '') }}
              </span>
            </div>
            <div class="model-meta">
              <div class="author">作者: 用户{{ item.userID }}</div>
            </div>
          </div>
        </div>
        <div class="license-column price-column">
          <select class="license-select" v-model="item.releaseModel" @change="handleLicenseChange(index)">
            <option value="个人授权">个人授权</option>
            <option value="企业授权">企业授权</option>
            <option value="企业扩展授权">企业扩展授权</option>
          </select>
        </div>
        <div class="price-column">
          {{ getModelPrice(item) }} 云币
        </div>
        <div class="action-column">
          <div class="model-actions">
            <button class="action-btn delete-btn" @click="handleDelete(index)">删除</button>
          </div>
        </div>
      </div>

      <!-- 空购物车提示 -->
      <div class="empty-cart" v-if="items.length === 0">
        <img src="https://picsum.photos/seed/empty/200/200" alt="空购物车" class="empty-img">
        <p>您的购物车是空的</p>
        <button class="go-shopping-btn" @click="goToShopping">去逛逛</button>
      </div>

      <!-- 分页组件 - 与参考代码样式一致 -->
      <div class="pagination-container" v-if="total > 0">
        <el-pagination @current-change="handleCurrentChange" :current-page="pageIndex" :page-size="pageSize"
          layout="total, prev, pager, next, jumper" :total="total" background>
        </el-pagination>
      </div>
    </div>

    <!-- 右侧结算明细区域 -->
    <div class="right-section">
      <div class="section-header">结算明细</div>
      <div class="empty-tip" v-if="selectedCount === 0">
        <img src="https://picsum.photos/seed/avatar/100/100" alt="提示图标" class="tip-icon">
        <p>左侧勾选模型，查看实际支付价格</p>
      </div>
      <div class="total-amount" v-else>
        <span>合计</span>
        <span class="amount">{{ totalAmount.toFixed(2) }}云币</span>
      </div>
      <div class="doc" v-if="selectedCount > 0">
        <span>购买前请确认授权类型及金额，确认购买即视为您已阅读并同意
          <a href="javascript:void(0)" class="discount-tag" @click="openBuyerAgreement">《智步云上模型网买家协议》</a>
          与
          <a href="javascript:void(0)" class="discount-tag" @click="openLicenseAgreement">《智步云上模型网授权协议》</a>
        </span>
      </div>
      <button class="pay-btn" :disabled="selectedCount === 0" @click="openPayConfirmModal">去付款</button>
    </div>

    <!-- 付款二次确认弹窗 -->
    <div class="pay-confirm-modal" v-if="showPayModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>确认付款</h3>
          <span class="close-btn" @click="closePayConfirmModal">&times;</span>
        </div>
        <div class="modal-body">
          <div class="total-info">
            <span>应付总额：</span>
            <span class="total-price">{{ totalAmount.toFixed(2) }}云币</span>
          </div>
          <div class="models-info">
            <p class="info-title">
              {{ selectedCount > 5 ? `共选择${selectedCount}个模型` : `已选择${selectedCount}个模型` }}
            </p>
            <!-- 模型数量≤5个时显示详情 -->
            <div class="models-list" v-if="selectedCount <= 5">
              <div class="model-item-mini" v-for="item in selectedModels" :key="item.id">
                <img :src="item.previewUrl[0]" :alt="item.title" class="mini-img">
                <div class="mini-info">
                  <div class="mini-name">{{ item.title || '未命名模型' }}</div>
                  <div class="mini-license">授权类型：{{ item.releaseModel }}</div>
                  <div class="mini-price">价格：{{
                    (getModelPrice(item) * licenseDiscount[item.releaseModel]).toFixed(2)
                  }}云币</div>
                </div>
              </div>
            </div>
            <!-- 模型数量>5个时简化显示 -->
            <div class="models-simple" v-else>
              <p class="simple-tip">模型数量较多，不展示详情，确认付款后将为您处理所有选中模型的购买流程</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-btn" @click="closePayConfirmModal">取消</button>
          <button class="confirm-btn" @click="confirmPay">确认付款</button>
        </div>
      </div>
    </div>
    <!-- 弹窗遮罩层 -->
    <div class="modal-mask" v-if="showPayModal" @click="closePayConfirmModal"></div>
  </div>
</template>

<script>
export default {
  name: 'CartPage',
  data() {
    return {
      // 模型列表数据
      items: [],
      // 授权类型价格折扣
      licenseDiscount: {
        '个人授权': 1,
        '企业授权': 1,
        '企业扩展授权': 1
      },
      // 付款确认弹窗显示状态
      showPayModal: false,
      // 分页相关参数（与参考代码一致）
      pageIndex: 1, // 当前页码，默认第一页
      pageSize: 4,  // 每页条数，默认4条
      total: 0      // 总数据条数
    };
  },
  computed: {
    isAllChecked: {
      get() {
        return this.items.length > 0 && this.items.every(item => item.checked);
      },
      set(value) {
        this.items.forEach(item => {
          item.checked = value;
        });
      }
    },
    // 选中商品数量
    selectedCount() {
      return this.items.filter(item => item.checked).length;
    },
    // 合计金额
    totalAmount() {
      return this.items.reduce((sum, item) => {
        if (item.checked) {
          const price = this.getModelPrice(item);
          const discountPrice = price * this.licenseDiscount[item.releaseModel];
          return sum + discountPrice;
        }
        return sum;
      }, 0);
    },
    // 选中的模型列表
    selectedModels() {
      return this.items.filter(item => item.checked);
    }
  },
  mounted() {
    this.getMyShoppingCart();
  },
  methods: {
    // 统一获取模型对应授权类型的价格
    getModelPrice(item) {
      switch (item.releaseModel) {
        case '个人授权':
          return item.licensingPrices || 0;
        case '企业授权':
          return item.enterprisePrices || 0;
        case '企业扩展授权':
          return item.expandPrices || 0;
        default:
          return 0;
      }
    },
    openBuyerAgreement() {
      window.open('/#/protocol/buyer-doc', '_blank');
    },
    openLicenseAgreement() {
      window.open('/#/protocol/license-doc', '_blank');
    },
    goToDetail(modelId) {
      const routeInfo = this.$router.resolve({
        path: '/detail',
        query: {
          id: modelId
        }
      });
      window.open(routeInfo.href, '_blank');
    },
    // 查询购物车 - 添加分页参数
    getMyShoppingCart() {
      // 构造分页请求参数
      const requestParams = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };

      this.$apiFun.getMyShoppingCart(requestParams)
        .then(res => {
          if (res.status == 200) {
            // 将接口返回的数据添加到items数组，并初始化checked状态
            this.items = res.obj.map(item => ({
              ...item,
              checked: false,  // 初始化勾选状态为未勾选
              // 确保fileFormat是数组格式
              fileFormat: Array.isArray(item.fileFormat) ? item.fileFormat : [item.fileFormat || ''],
              // 如果没有releaseModel字段，设置默认值
              releaseModel: item.releaseModel || '个人授权',
              // 补充价格字段初始化，防止字段缺失
              licensingPrices: item.licensingPrices || 0,
              enterprisePrices: item.enterprisePrices || 0,
              expandPrices: item.expandPrices || 0
            }));
            // 设置总条数（与参考代码一致，从res.num获取）
            this.total = res.num || 0;
          } else {
            this.$message.error(res.msg || '获取购物车数据失败');
          }
        })
        .catch(error => {
          console.error('获取购物车失败:', error);
          this.$message.error('获取购物车数据异常');
        });
    },
    // 全选/取消全选
    handleSelectAll() {
      // 由computed的setter自动处理
    },
    // 单个模型勾选
    handleItemCheck(index) {
      // 由v-model双向绑定自动处理
    },
    // 授权类型变更（影响价格）
    handleLicenseChange(index) {
      const item = this.items[index];
      if (item.releaseModel === '个人授权') {

      } else if (item.releaseModel === '企业授权') {

      } else if (item.releaseModel === '企业扩展授权') {

      }
    },
    // 统一的删除模型方法
    deleteModels(ids) {
      if (!Array.isArray(ids) || ids.length === 0) {
        this.$message.warning('请选择要删除的模型');
        return;
      }

      this.$apiFun.postDeleMyShoppingCart({ id: ids })
        .then(res => {
          if (res.status == 200) {
            this.$message.success(ids.length > 1 ? `已成功删除${ids.length}个模型` : '删除成功');
            // 删除后重新加载当前页数据
            this.getMyShoppingCart();
          } else {
            this.$message.error(res.msg || '删除失败');
          }
        })
        .catch(error => {
          console.error('删除模型失败:', error);
          this.$message.error('删除模型数据异常');
        });
    },
    // 删除单个模型
    handleDelete(index) {
      const modelId = this.items[index].id;
      this.deleteModels([modelId]);
    },
    // 删除选中模型
    handleDeleteSelected() {
      const selectedIds = this.items.filter(item => item.checked).map(item => item.id);
      this.deleteModels(selectedIds);
    },
    // 打开付款确认弹窗
    openPayConfirmModal() {
      this.showPayModal = true;
    },
    // 关闭付款确认弹窗
    closePayConfirmModal() {
      this.showPayModal = false;
    },
    // 确认付款
    confirmPay() {
      this.handlePay();
      this.closePayConfirmModal();
    },
    // 去付款
    handlePay() {
      const modelIdList = this.items.filter(item => item.checked).map(item => item.modelId);
      const priceList = this.items.filter(item => item.checked).map(item => {
        return this.getModelPrice(item) * this.licenseDiscount[item.releaseModel];
      });
      this.$apiFun.postBuyNows({ modelId: modelIdList, amounts: priceList })
        .then(res => {
          if (res.status === 200) {
            this.$message.success("模型购买成功！您可以立即下载");
            // 购买成功后重新加载购物车
            this.getMyShoppingCart();
          } else if (res.status === 888) {
            this.$message.warning("账户余额不足，请先充值后再试");
          } else {
            this.$message.error(`购买失败：${res.message || '未知错误'}`);
          }
        })
        .catch(err => {
          console.error('模型去付款失败:', err);
        });
    },
    goToShopping() {
      this.$router.push('/models');
    },
    // 分页 - 当前页码改变（与参考代码一致）
    handleCurrentChange(val) {
      this.pageIndex = val; // 更新当前页码
      this.getMyShoppingCart(); // 重新请求数据
    }
  }
};
</script>

<style lang="less" scoped>
// 深色主题变量
@bg-primary: #1a1a1a;
@bg-secondary: #080a12;
@text-primary: #e0e0e0;
@text-secondary: #a0a0a0;
@accent-red: #0ea5e9;
@border-color: #444;
@tag-bg: #3a3a3a;
@hover-bg: rgba(255, 255, 255, 0.1);

// 基础页面样式 - 核心适配
.cart-page {
  display: flex;
  gap: 20px;
  color: @text-primary;
  min-height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden; // 防止页面横向溢出

  // 响应式：小屏时改为垂直布局
  @media screen and (max-width: 992px) {
    flex-direction: column;
    padding: 10px;
    gap: 15px;
  }

  @media screen and (max-width: 576px) {
    padding: 5px;
    gap: 10px;
  }

  .left-section,
  .right-section {
    border-radius: 4px;
    background-color: @bg-secondary;
    padding: 20px;
    box-sizing: border-box;
    width: 100%; // 确保占满容器

    // 响应式：小屏时调整内边距
    @media screen and (max-width: 768px) {
      padding: 15px;
    }

    @media screen and (max-width: 576px) {
      padding: 10px;
    }
  }

  .left-section {
    flex: 3;
    min-width: 0; // 解决flex容器溢出问题

    @media screen and (max-width: 992px) {
      flex: none;
    }
  }

  .right-section {
    flex: 1;
    min-width: 300px; // 保证结算区域最小宽度
    align-self: flex-start; // 防止高度拉伸

    @media screen and (max-width: 992px) {
      flex: none;
      min-width: 0;
    }

    @media screen and (max-width: 576px) {
      min-width: 0;
    }
  }

  .section-header {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 15px;

    @media screen and (max-width: 768px) {
      font-size: 15px;
      margin-bottom: 12px;
    }

    @media screen and (max-width: 576px) {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }

  // 选择栏样式 - 核心响应式优化
  .selection-bar {
    display: flex;
    align-items: center;
    padding: 10px 0;
    border-bottom: 1px solid @border-color;
    margin-bottom: 15px;
    font-size: 14px;
    color: @text-secondary;
    width: 100%;
    flex-wrap: wrap; // 允许换行
    gap: 8px; // 添加间隙，避免挤压

    @media screen and (max-width: 768px) {
      font-size: 13px;
      padding: 8px 0;
      margin-bottom: 12px;
    }

    @media screen and (max-width: 576px) {
      font-size: 12px;
      padding: 5px 0;
      margin-bottom: 10px;
      gap: 5px;
    }

    .select-column {
      width: auto; // 移除固定宽度
      min-width: 120px; // 最小宽度保证可用
      padding-left: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex-shrink: 0; // 禁止收缩

      @media screen and (max-width: 576px) {
        min-width: 100px;
        padding-left: 5px;
      }

      .checkbox {
        margin-right: 8px;

        @media screen and (max-width: 576px) {
          margin-right: 5px;
        }
      }

      .select-all-btn,
      .delete-selected-btn {
        background-color: transparent;
        border: 1px solid @border-color;
        color: @text-primary;
        padding: 3px 6px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 12px;
        margin-right: 8px;

        @media screen and (max-width: 576px) {
          font-size: 11px;
          padding: 2px 4px;
          margin-right: 5px;
        }

        &:last-child {
          margin-right: 0;
        }
      }

      .delete-selected-btn {
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }

    .info-column {
      flex: 1;
      padding-left: 15px; // 减小左侧内边距
      box-sizing: border-box;
      min-width: 100px; // 最小宽度

      @media screen and (max-width: 768px) {
        padding-left: 10px;
      }

      @media screen and (max-width: 576px) {
        padding-left: 5px;
      }
    }

    .license-column {
      width: auto; // 移除固定宽度
      min-width: 100px; // 最小宽度
      text-align: center;
      flex-shrink: 0;
      padding: 0 5px;

      @media screen and (max-width: 576px) {
        min-width: 80px;
      }
    }

    .price-column {
      width: auto; // 移除固定宽度
      min-width: 70px; // 最小宽度
      text-align: center;
      flex-shrink: 0;
      padding: 0 5px;

      @media screen and (max-width: 576px) {
        min-width: 60px;
      }
    }

    .action-column {
      width: auto; // 移除固定宽度
      min-width: 80px; // 最小宽度
      text-align: center;
      flex-shrink: 0;
      padding: 0 5px;

      @media screen and (max-width: 576px) {
        min-width: 70px;
      }
    }

    .info-icon {
      font-size: 12px;
      color: @text-secondary;
      margin-left: 5px;
      cursor: help;

      @media screen and (max-width: 576px) {
        font-size: 10px;
        margin-left: 3px;
      }
    }
  }

  // 模型项样式 - 响应式优化
  .model-item {
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid @border-color;
    width: 100%;
    flex-wrap: wrap; // 允许换行
    gap: 10px; // 添加间隙

    @media screen and (max-width: 768px) {
      padding: 12px 0;
      gap: 8px;
    }

    @media screen and (max-width: 576px) {
      padding: 10px 0;
      gap: 5px;
      flex-direction: column; // 移动端垂直排列
      align-items: flex-start;
    }

    .select-column {
      width: auto; // 移除固定宽度
      min-width: 120px; // 最小宽度
      padding-left: 10px;
      box-sizing: border-box;
      flex-shrink: 0;

      @media screen and (max-width: 576px) {
        min-width: 100%;
        padding-left: 5px;
      }

      .model-checkbox {
        margin-right: 10px;

        @media screen and (max-width: 576px) {
          margin-right: 5px;
        }
      }
    }

    .info-column {
      flex: 1;
      display: flex;
      padding-left: 0;
      cursor: pointer;
      min-width: 200px; // 最小宽度

      @media screen and (max-width: 768px) {
        min-width: 180px;
      }

      @media screen and (max-width: 576px) {
        min-width: 100%;
      }

      .model-img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        border-radius: 4px;
        margin-right: 12px;
        flex-shrink: 0;

        @media screen and (max-width: 768px) {
          width: 80px;
          height: 80px;
          margin-right: 10px;
        }

        @media screen and (max-width: 576px) {
          width: 70px;
          height: 70px;
          margin-right: 8px;
        }
      }

      .model-text {
        flex: 1;
        min-width: 0; // 解决文字溢出问题

        .model-name {
          font-size: 14px;
          margin-bottom: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;

          @media screen and (max-width: 768px) {
            font-size: 13px;
            margin-bottom: 5px;
          }

          @media screen and (max-width: 576px) {
            font-size: 12px;
            margin-bottom: 4px;
          }
        }

        .tags {
          display: flex;
          gap: 5px;
          margin-bottom: 6px;
          flex-wrap: wrap;

          @media screen and (max-width: 576px) {
            gap: 3px;
            margin-bottom: 4px;
          }

          .tag {
            display: inline-block;
            background-color: @tag-bg;
            color: #ccc;
            font-size: 10px;
            padding: 2px 5px;
            border-radius: 3px;
            white-space: nowrap;

            @media screen and (max-width: 576px) {
              font-size: 9px;
              padding: 1px 3px;
            }
          }
        }

        .model-meta {
          display: flex;
          gap: 15px;
          font-size: 12px;
          color: @text-secondary;
          align-items: center;
          flex-wrap: wrap; // 允许换行

          @media screen and (max-width: 768px) {
            font-size: 11px;
            gap: 10px;
          }

          @media screen and (max-width: 576px) {
            font-size: 10px;
            gap: 5px;
          }

          .author {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 200px;

            @media screen and (max-width: 576px) {
              max-width: 100%;
              width: 100%;
            }
          }

          .type {
            white-space: nowrap;
          }
        }
      }
    }

    .license-column {
      width: auto; // 移除固定宽度
      min-width: 100px; // 最小宽度
      text-align: center;
      flex-shrink: 0;
      padding: 0 5px;

      @media screen and (max-width: 576px) {
        min-width: 100%;
        text-align: left;
        padding-left: 5px;
      }

      .license-select {
        width: 100px;
        background-color: @bg-primary;
        color: @text-primary;
        border: 1px solid @border-color;
        padding: 4px;
        border-radius: 4px;
        margin: 0 auto;
        font-size: 12px;

        @media screen and (max-width: 768px) {
          width: 90px;
          font-size: 11px;
          padding: 3px;
        }

        @media screen and (max-width: 576px) {
          width: 100%;
          max-width: 120px;
          margin: 0;
        }
      }
    }

    .price-column {
      width: auto; // 移除固定宽度
      min-width: 70px; // 最小宽度
      text-align: center;
      color: @accent-red;
      font-size: 14px;
      flex-shrink: 0;
      padding: 0 5px;

      @media screen and (max-width: 768px) {
        font-size: 13px;
        min-width: 60px;
      }

      @media screen and (max-width: 576px) {
        font-size: 12px;
        min-width: 100%;
        text-align: left;
        padding-left: 5px;
      }
    }

    .action-column {
      width: auto; // 移除固定宽度
      min-width: 80px; // 最小宽度
      text-align: center;
      flex-shrink: 0;
      padding: 0 5px;

      @media screen and (max-width: 576px) {
        min-width: 100%;
        text-align: left;
        padding-left: 5px;
      }

      .model-actions {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;

        @media screen and (max-width: 576px) {
          flex-direction: row;
          align-items: center;
          gap: 8px;
        }

        .action-btn {
          background-color: transparent;
          border: 1px solid @border-color;
          color: @text-primary;
          padding: 2px 6px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 11px;
          width: 65px;

          @media screen and (max-width: 768px) {
            font-size: 10px;
            padding: 2px 4px;
            width: 60px;
          }

          @media screen and (max-width: 576px) {
            width: auto;
            padding: 3px 8px;
          }

          &.delete-btn {
            color: @accent-red;
            border-color: @accent-red;
          }
        }
      }
    }
  }

  // 空购物车样式 - 响应式优化
  .empty-cart {
    text-align: center;
    padding: 50px 0;

    @media screen and (max-width: 768px) {
      padding: 40px 0;
    }

    @media screen and (max-width: 576px) {
      padding: 30px 0;
    }

    .empty-img {
      width: 150px;
      height: 150px;
      opacity: 0.5;
      margin-bottom: 20px;

      @media screen and (max-width: 768px) {
        width: 120px;
        height: 120px;
        margin-bottom: 15px;
      }

      @media screen and (max-width: 576px) {
        width: 100px;
        height: 100px;
        margin-bottom: 10px;
      }
    }

    p {
      color: @text-secondary;
      margin-bottom: 20px;

      @media screen and (max-width: 768px) {
        margin-bottom: 15px;
        font-size: 14px;
      }

      @media screen and (max-width: 576px) {
        margin-bottom: 10px;
        font-size: 13px;
      }
    }

    .go-shopping-btn {
      background-color: @accent-red;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 4px;
      cursor: pointer;

      @media screen and (max-width: 768px) {
        padding: 7px 14px;
        font-size: 13px;
      }

      @media screen and (max-width: 576px) {
        padding: 6px 12px;
        font-size: 12px;
      }
    }
  }

  // 右侧结算区域样式 - 响应式优化
  .empty-tip {
    text-align: center;
    padding: 30px 0;

    @media screen and (max-width: 768px) {
      padding: 25px 0;
    }

    @media screen and (max-width: 576px) {
      padding: 20px 0;
    }

    .tip-icon {
      width: 100px;
      height: 100px;
      margin-bottom: 10px;
      border-radius: 10%;

      @media screen and (max-width: 768px) {
        width: 80px;
        height: 80px;
        margin-bottom: 8px;
      }

      @media screen and (max-width: 576px) {
        width: 60px;
        height: 60px;
        margin-bottom: 6px;
      }
    }

    p {
      font-size: 14px;
      color: @text-secondary;

      @media screen and (max-width: 768px) {
        font-size: 13px;
      }

      @media screen and (max-width: 576px) {
        font-size: 12px;
        padding: 0 10px;
      }
    }
  }

  .total-amount {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid @border-color;
    border-bottom: 1px solid @border-color;

    @media screen and (max-width: 768px) {
      padding: 12px 0;
    }

    @media screen and (max-width: 576px) {
      padding: 10px 0;
    }

    .amount {
      font-size: 24px;
      color: @accent-red;

      @media screen and (max-width: 768px) {
        font-size: 20px;
      }

      @media screen and (max-width: 576px) {
        font-size: 18px;
      }
    }
  }

  .doc {
    font-size: 12px;
    margin: 10px 0;
    cursor: pointer;
    line-height: 1.4;
  }

  .discount-tag {
    font-size: 12px;
    color: #ffb042;
    margin: 10px 0;
    cursor: pointer;
    line-height: 1.4;
    text-decoration: none;

    @media screen and (max-width: 768px) {
      font-size: 11px;
      margin: 8px 0;
    }

    @media screen and (max-width: 576px) {
      font-size: 10px;
      margin: 6px 0;
    }

    .discount-desc {
      color: @text-secondary;
      margin-left: 5px;
      display: block; // 移动端换行显示
      margin-top: 3px;

      @media screen and (min-width: 577px) {
        display: inline;
        margin-top: 0;
      }
    }
  }

  .pay-btn {
    width: 100%;
    background-color: @accent-red;
    color: #fff;
    border: none;
    padding: 12px;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    margin-top: 20px;

    @media screen and (max-width: 768px) {
      padding: 10px;
      font-size: 15px;
      margin-top: 15px;
    }

    @media screen and (max-width: 576px) {
      padding: 8px;
      font-size: 14px;
      margin-top: 10px;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  // 付款确认弹窗样式 - 响应式优化
  .pay-confirm-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1001;
    width: 500px;
    max-width: 90vw; // 关键：限制最大宽度为视口90%
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    overflow: hidden;

    @media screen and (max-width: 576px) {
      max-width: 95vw;
    }

    .modal-content {
      background-color: @bg-primary;
      width: 100%;
    }

    .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 20px;
      border-bottom: 1px solid @border-color;
      background-color: @bg-primary;

      @media screen and (max-width: 576px) {
        padding: 10px 15px;
      }

      h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;

        @media screen and (max-width: 576px) {
          font-size: 14px;
        }
      }

      .close-btn {
        font-size: 20px;
        cursor: pointer;
        color: @text-secondary;

        &:hover {
          color: @text-primary;
        }

        @media screen and (max-width: 576px) {
          font-size: 18px;
        }
      }
    }

    .modal-body {
      padding: 20px;
      max-height: 60vh;
      overflow-y: auto;
      background-color: @bg-primary;
      box-sizing: border-box;

      @media screen and (max-width: 576px) {
        padding: 15px 10px;
        max-height: 50vh;
      }

      .total-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 15px;
        border-bottom: 1px solid @border-color;
        margin-bottom: 15px;

        @media screen and (max-width: 576px) {
          padding-bottom: 10px;
          margin-bottom: 10px;
        }

        .total-price {
          font-size: 18px;
          color: @accent-red;
          font-weight: 500;

          @media screen and (max-width: 576px) {
            font-size: 16px;
          }
        }
      }

      .models-info {
        .info-title {
          font-size: 14px;
          margin-bottom: 10px;
          color: @text-secondary;

          @media screen and (max-width: 576px) {
            font-size: 12px;
            margin-bottom: 8px;
          }
        }

        .models-list {
          display: flex;
          flex-direction: column;
          gap: 10px;

          @media screen and (max-width: 576px) {
            gap: 8px;
          }

          .model-item-mini {
            display: flex;
            align-items: center;
            padding: 10px;
            background-color: @bg-primary;
            border-radius: 4px;

            @media screen and (max-width: 576px) {
              padding: 8px;
            }

            .mini-img {
              width: 60px;
              height: 60px;
              object-fit: cover;
              border-radius: 4px;
              margin-right: 10px;
              flex-shrink: 0;

              @media screen and (max-width: 576px) {
                width: 50px;
                height: 50px;
                margin-right: 8px;
              }
            }

            .mini-info {
              flex: 1;
              min-width: 0;

              .mini-name {
                font-size: 14px;
                margin-bottom: 5px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                @media screen and (max-width: 576px) {
                  font-size: 12px;
                  margin-bottom: 3px;
                }
              }

              .mini-license,
              .mini-price {
                font-size: 12px;
                color: @text-secondary;
                margin-bottom: 3px;

                @media screen and (max-width: 576px) {
                  font-size: 10px;
                  margin-bottom: 2px;
                }
              }

              .mini-price {
                color: @accent-red;
              }
            }
          }
        }

        .models-simple {
          padding: 20px;
          text-align: center;
          color: @text-secondary;
          font-size: 14px;
          background-color: @bg-primary;
          border-radius: 4px;

          @media screen and (max-width: 576px) {
            padding: 15px 10px;
            font-size: 12px;
          }
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
      padding: 15px 20px;
      border-top: 1px solid @border-color;
      background-color: @bg-primary;

      @media screen and (max-width: 576px) {
        padding: 10px 15px;
        gap: 8px;
        justify-content: center;
      }

      .cancel-btn {
        padding: 8px 16px;
        background-color: transparent;
        border: 1px solid @border-color;
        color: @text-primary;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          background-color: #2a2a2a;
        }

        @media screen and (max-width: 576px) {
          padding: 6px 12px;
          font-size: 12px;
        }
      }

      .confirm-btn {
        padding: 8px 16px;
        background-color: @accent-red;
        color: #fff;
        border: none;
        border-radius: 4px;
        cursor: pointer;

        &:hover {
          opacity: 0.9;
        }

        @media screen and (max-width: 576px) {
          padding: 6px 12px;
          font-size: 12px;
        }
      }
    }
  }

  // 弹窗遮罩层
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  // 分页组件样式 - 与参考代码完全一致
  .pagination-container {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
  }

  // 核心：修改分页组件的背景色、字体色，与参考代码一致
  :deep(.el-pagination) {
    background-color: transparent !important;

    .el-pagination__total {
      color: #e0e0e0 !important;
      font-size: 14px !important;
    }

    .el-pager {
      li {
        background-color: #080a12 !important;
        color: #a0a0a0 !important;
        border: 1px solid #424242 !important;
        margin: 0 2px !important;

        &:hover {
          background-color: rgba(255, 255, 255, 0.1) !important;
          color: #0ea5e9 !important;
          border-color: #0ea5e9 !important;
        }

        &.active {
          background-color: #0ea5e9 !important;
          color: #ffffff !important;
          border-color: #0ea5e9 !important;
        }
      }
    }

    .btn-prev,
    .btn-next {
      background-color: @bg-secondary !important;
      color: @text-secondary !important;
      border: 1px solid @border-color !important;
      min-width: 30px !important;
      margin: 0 2px !important;
      
      &.disabled {
        background-color: darken(@bg-secondary, 5%) !important;
        color: darken(@text-secondary, 20%) !important;
        border-color: darken(@border-color, 10%) !important;
        cursor: not-allowed !important;
        
        &:hover {
          background-color: darken(@bg-secondary, 5%) !important;
          color: darken(@text-secondary, 20%) !important;
          border-color: darken(@border-color, 10%) !important;
        }
      }
      
      &:not(.disabled):hover {
        background-color: @hover-bg !important;
        color: @accent-red !important;
        border-color: @accent-red !important;
      }
      
      .el-icon {
        font-size: 12px !important;
        font-weight: bold !important;
      }
    }

    .el-pagination__jump {
      color: #a0a0a0 !important;

      .el-input__inner {
        background-color: #080a12 !important;
        color: #e0e0e0 !important;
        border: 1px solid #424242 !important;

        &:focus {
          border-color: #0ea5e9 !important;
        }
      }
    }
  }
}
</style>